import { render, staticRenderFns } from "./KasbonDriverView.vue?vue&type=template&id=241fdd7d"
import script from "./KasbonDriverView.vue?vue&type=script&lang=js"
export * from "./KasbonDriverView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports